import { alpha, createTheme } from "@mui/material/styles"

/**
 * Portfolio theme. Pattern copied from SuperAdmin moog-patch-maker + HeyJoe
 * ThemeProvider / createTheme basics. Navy plate, electric blue (not purple).
 */
const navy = "#070b14"
const plate = "#0f1726"
const plateElevated = "#162235"
const blue = "#007fff"
const blueLight = "#4da6ff"
const ink = "#e8eefc"
const border = alpha("#ffffff", 0.1)

export const portfolioTheme = createTheme({
  cssVariables: true,
  palette: {
    mode: "dark",
    primary: { main: blue, light: blueLight, dark: "#0060c2", contrastText: "#041018" },
    secondary: { main: "#7eb6f5" },
    background: { default: navy, paper: plate },
    text: { primary: ink, secondary: alpha(ink, 0.68) },
    divider: border,
  },
  typography: {
    fontFamily: '"Sora", system-ui, sans-serif',
    h1: {
      fontFamily: '"Space Grotesk", "Sora", system-ui, sans-serif',
      fontWeight: 600,
      letterSpacing: "-0.03em",
      lineHeight: 1.05,
    },
    h2: {
      fontFamily: '"Space Grotesk", "Sora", system-ui, sans-serif',
      fontWeight: 600,
      letterSpacing: "-0.02em",
    },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: { borderRadius: 14 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          overflowX: "hidden",
          scrollBehavior: "smooth",
        },
        body: {
          minHeight: "100vh",
          overflowX: "hidden",
          backgroundColor: navy,
          backgroundImage: `radial-gradient(ellipse 70% 45% at 50% -15%, ${alpha(blue, 0.18)}, transparent),
            radial-gradient(ellipse 50% 35% at 100% 100%, ${alpha(blueLight, 0.08)}, transparent)`,
        },
        "#root": {
          overflowX: "hidden",
          maxWidth: "100%",
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 999, fontWeight: 700 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: alpha(plateElevated, 0.9),
          border: `1px solid ${border}`,
        },
      },
    },
  },
})
